export default [
    {
        label: '资讯'
    },
    {
        label: '明星'
    },
    {
        label: '活动'
    },
    {
        label: '话题'
    }
]
